import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import { AuthenticationService } from '../../services/authentication.service';
import CadenaService from '../../services/cadena.service';
import * as Constants from '../../constants'; 
import './Cadena.css';
import Table from './TableCadena';
import { FaPlus } from "react-icons/fa";
import { IoSearch } from "react-icons/io5";
import { FaFilter } from "react-icons/fa6";
import PopUpCadena from './NuevaCadena';
import useColumnsCadena from "../../hooks/useColumnsCadena";
import Select from 'react-select'

const Cadena = () => {
	const [seen, setSeen] = useState(false);
	
	const authenticationService = new AuthenticationService();
	const navigate = useNavigate();
	const [t] = useTranslation("global");
	const [selectedCadena, setSelectedCadena] = useState(null);
	const [listaCadenas, setListaCadenas] = useState([]);
	const [filtroNombre, setFiltroNombre] = useState('');		
	const [activo, setActivo] = useState(1);
	
	useEffect(() => {
		const authentication = authenticationService.getAuthenticationSession();
		
		if(authentication === null) {
			navigate(Constants.ROUTE_ROOT);
		} else {
			obtenerListaCadenas();
		}
	}, [navigate]);
	
	const obtenerListaCadenas = async () => {
		await CadenaService.getCadenas()
		.then(response => response.json())
		.then(data => {
			setListaCadenas(data);
		});
	}
	
	const obtenerListaCadenasByParams = async (nombre, activo) => {
		await CadenaService.getCadenasByParams(nombre, activo)
		.then(response => response.json())
		.then(data => setListaCadenas(data));
	}
	
	function togglePop() {
		
		if(selectedCadena != null) {
			setSelectedCadena(null);
		}
		
		setSeen(!seen);
		
	}
	
	function guardarSelectedCadena(cadena) {
		setSelectedCadena(cadena);

	}
	
	const onChangeFiltroNombre = (ev) => {
		setFiltroNombre(ev.target.value)		
		obtenerListaCadenasByParams(ev.target.value, activo);
	}
	
	const optionsActivo = [
		{ value: 1, label: t('app.label.si') },
		{ value: 0, label: t('app.label.no') }
	];
	
	const onChangeFiltroActivo = (ev) => {
		setActivo(ev.value);
		obtenerListaCadenasByParams(filtroNombre, ev.value);
	}
	
	const limpiarFiltros = () => {
		setFiltroNombre('')
		setActivo(1);
		obtenerListaCadenas();
	}
	
	const colorFiltros = {
	  menuList: styles => ({
	    ...styles,
	    background: '#FAE6F1',
	  }),
	  option: (styles, { isFocused, isSelected }) => ({
	    ...styles,
	    background: isSelected
	        ? '#91005F'
	        : '#FAE6F1',
	    zIndex: 1,
	    "&:hover": {
			background: 'rgba(145, 0, 95, 0.2)',
			color: '#000'
		},
	  }),
	  menu: base => ({
	    ...base,
	    zIndex: 100
	  }),
	}
	
	return(<main className="mainContainerPage">
			<section className="principal-container">
				<div className={'container-crearComponente'}>
					<h1 className={'title-Componente'}>{t("app.header.enlaces.camas")}</h1>
					<button className={'btn-general'} onClick={togglePop}><FaPlus size="10" /><p className="txt-btn-nuevoCompt">{t("app.cadena.nuevaCadena")}</p></button>
					
					{seen ? <PopUpCadena toggle={togglePop}
						selectedCadena={selectedCadena}
						limpiarFiltros={limpiarFiltros}
						loadCadenas={obtenerListaCadenas}
						loadCadenasByParams={obtenerListaCadenasByParams}
						filtroNombre={filtroNombre}
						filtroActivo={activo}
					/> : null}
				</div>
				
				<div className="container-filtro-tabla">
					<div className="container-filtro-Cadena">
						<div className="div_img-filtroInputText">
							<IoSearch className="iconSearch" size="20" />
							{/*Falta funcionalidad del input*/}
							<input placeholder={t('app.placeholder.buscarCadena')}
							className={'filtroInputText'}
							type="search" 
							value={filtroNombre}
							onChange={onChangeFiltroNombre}/>
						</div>
						
						<div className="container-selects-btn-limpiarFiltro-Establ">
							<div className={'filterItem'}>
								<label className={'fieldsetLabel'}>{t("app.popup.label.activo")}</label>
								<Select
										className={'filtroSelect'}
										defaultValue={optionsActivo[0]}
										value={optionsActivo.find(e => e.value === activo)}
										options={optionsActivo}
										onChange={option => onChangeFiltroActivo(option)}
										isSearchable={false}
										styles={colorFiltros}	
									/>
							</div>
							
							<button className={'btn-limpiarFiltro'} onClick={limpiarFiltros}><FaFilter /> <p className="txt-btn-limpiarFiltro">{t("app.cama.limpiarFiltros")}</p></button>
							
							
						</div>
					
					</div>
					
					<div className="containerTabla">
						<Table columns={useColumnsCadena(togglePop, guardarSelectedCadena)} data={listaCadenas}/>
					</div>
				</div>
				
				
			</section>
			</main>);
}

export default Cadena